import loadable from "@loadable/component";
import { allDependSheets } from "../../../ssui/types/fields";
import { StrictViewType } from "./types";

const ViewRender = loadable(() => import("./render"));

export const viewTypeHkrShipAllPlantsSummary: StrictViewType = {
  key: "hkrShipAllPlantsSummary",
  displayName: "HKR-SHIP 運行集約表",
  render: ViewRender as any,
  dependSheets: allDependSheets,
  configSchemas: [],
  isDisabledEditHistoryShortcuts: true,
};
